import { memo } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

function CompanyCard({ title, icon, linkListHtml, isReverse = false }) {
  return (
    <div
      className={clsx("company-card", isReverse ? "flex-row" : "flex-row-reverse md-l:flex-row")}
    >
      <div className="icon">
        <img src={icon} alt="company-icon" />
      </div>
      <div className="text-container">
        <p className={clsx("title", isReverse ? "text-left" : "text-right")}>{title}</p>
        <div className="content" dangerouslySetInnerHTML={{ __html: linkListHtml }}></div>
      </div>
    </div>
  );
}

export default memo(CompanyCard);

CompanyCard.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  linkListHtml: PropTypes.string,
  isReverse: PropTypes.bool,
};
